import img1 from '../images/cards/blackJack/card-1.jpg'
import img2 from '../images/cards/blackJack/card-2.jpg'
import img3 from '../images/cards/blackJack/card-3.jpg'
import img4 from '../images/cards/blackJack/card-4.jpg'
import img5 from '../images/cards/blackJack/card-5.jpg'
import img6 from '../images/cards/blackJack/card-6.jpg'
import img7 from '../images/cards/blackJack/card-7.jpg'
import img8 from '../images/cards/blackJack/card-8.jpg'
import img9 from '../images/cards/blackJack/card-9.jpg'
import img10 from '../images/cards/blackJack/card-10.jpg'
import img11 from '../images/cards/blackJack/card-11.jpg'
import img12 from '../images/cards/blackJack/card-12.jpg'

export const BlackJackDB = [
  {
    title: 'Black Jack',
    image: img1
  },
  {
    title: 'Black Jack',
    image: img2
  },
  {
    title: 'Black Jack',
    image: img3
  },
  {
    title: 'Black Jack',
    image: img4
  },
  {
    title: 'Black Jack',
    image: img5
  },
  {
    title: 'Black Jack',
    image: img6
  },
  {
    title: 'Black Jack',
    image: img7
  },
  {
    title: 'Black Jack',
    image: img8
  },
  {
    title: 'Black Jack',
    image: img9
  },
  {
    title: 'Black Jack',
    image: img10
  },
  {
    title: 'Black Jack',
    image: img11
  },
  {
    title: 'Black Jack',
    image: img12
  },

]